import { lazy } from 'react';
import { Switch } from 'react-router-dom';
import { Signup } from '@client/components/routes/Signup';
import { Intent } from '@client/components/routes/Signup/Intent';
import { Artist } from '@client/components/routes/Signup/Artist';
import { Host } from '@client/components/routes/Signup/Host';
import { ProfileTypes } from '@sda/enums';
import { NoLoginRoute, ProtectedRoute } from '@client/components/common/Route';

export default () => (
  <Switch>
    <NoLoginRoute
      path="/signup"
      component={Signup}
      exact
    />

    <ProtectedRoute
      path="/signup/intent"
      component={Intent}
      exact
    />

    <ProtectedRoute
      path="/signup/host"
      exact
      component={Host}
    />

    <ProtectedRoute
      path="/signup/artist"
      exact
      component={Artist}
    />

    <ProtectedRoute
      path="/signup/artist/:step"
      load={lazy(() => import(/* webpackPrefetch: true */ '@client/components/routes/Signup/Artist/Steps'))}
      profileType={ProfileTypes.ACT}
      exact
    />

    <ProtectedRoute
      path="/signup/host/:step"
      load={lazy(() => import(/* webpackPrefetch: true */ '@client/components/routes/Signup/Host/Steps'))}
      profileType={ProfileTypes.VENUE}
      exact
    />
  </Switch>
);
